module.exports = __webpack_public_path__ + "static/media/Super Banquete_Web2025.e9844632.png";